var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"98%","background":"#fff","width":"98%","margin":"10px auto"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"img"},[_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t}"}],attrs:{"id":"two"}},[_c('img',{attrs:{"src":require("../assets/img/door/bTwo.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t}"}],attrs:{"id":"three"}},[_c('img',{attrs:{"src":require("../assets/img/door/bThree.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t}"}],attrs:{"id":"door"}},[_c('img',{attrs:{"src":require("../assets/img/door/door.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t}"}],attrs:{"id":"jjj1"}},[_c('img',{attrs:{"src":require("../assets/img/door/gear.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t}"}],attrs:{"id":"jjj2"}},[_c('img',{attrs:{"src":require("../assets/img/door/bFour.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t}"}],attrs:{"id":"seven"}},[_c('img',{attrs:{"src":require("../assets/img/door/bSeven.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t}"}],attrs:{"id":"tou"}},[_c('img',{attrs:{"src":require("../assets/img/door/tou.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t}"}],attrs:{"id":"arm"}},[_c('img',{attrs:{"src":require("../assets/img/door/arm.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t}"}],attrs:{"id":"screan"}},[_c('img',{attrs:{"src":require("../assets/img/door/screan.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t}"}],attrs:{"id":"ai"}},[_c('img',{attrs:{"src":require("../assets/img/door/ai.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t}"}],attrs:{"id":"bottom"}},[_c('img',{attrs:{"src":require("../assets/img/door/bottom.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t}"}],attrs:{"id":"five"}},[_c('img',{attrs:{"src":require("../assets/img/door/bFive.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t}"}],attrs:{"id":"six"}},[_c('img',{attrs:{"src":require("../assets/img/door/bSix.png"),"alt":""}})])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"button"},[_vm._v("进入CocoBlockly编程平台")]),_vm._v(" "),_c('video',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"musicC","src":require('../assets/music/click.mp3')}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip"},[_c('img',{attrs:{"src":require("../assets/img/door/tips.png"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right"},[_c('img',{attrs:{"src":require("../assets/img/right.png"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xian"},[_c('img',{attrs:{"src":require("../assets/img/door/xian.png"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a163b80a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/door.vue
// module id = null
// module chunks = 